"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
var _focusMode = require("../../components/focusMode");
var _BaseButton = require("./BaseButton");
/** @jsxRuntime classic */
/** @jsx jsx */

const Button = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    type = "button",
    appearance = "primary",
    ...props
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    if (!props.children && (props.iconBefore || props.iconAfter) && !props["aria-label"] && !props["aria-labelledby"]) {
      console.warn("No aria-label or aria-labelledby provided to ICON-ONLY BUTTON component!");
    }
  }
  const {
    focusMode
  } = (0, _focusMode.useFocusMode)({
    isDisabled: appearance !== "borderless"
  });
  return (0, _core.jsx)(_BaseButton.BaseButton, (0, _extends2.default)({}, props, {
    appearance: appearance,
    type: type,
    innerRef: ref,
    focusMode: focusMode,
    renderAs: "button"
  }));
});
exports.Button = Button;
//# sourceMappingURL=Button.js.map